import { FlipWords } from '../../Components/ui/flip-words.js';
import { useSuggestedQueries } from '../../api/cache/appConfigQueryOptions.js';
import { useTheme } from '@mui/material';
import { Sparkles } from 'lucide-react';
import React__default, { memo } from 'react';
import { AnimatedMasonryGrid } from './AnimatedMasonryGrid.js';
import { ConciergeWelcomeEmbedded } from './ConciergeWelcomeEmbedded.js';
import { usePageContext } from '../hooks/usePageContext.js';

function FlipWordsDemo() {
    const words = [
        'find the perfect gift for your mom',
        'save on your weekly grocery shopping',
        'find a Halloween costume for your dog',
    ];
    const theme = useTheme();
    return (React__default.createElement("div", { className: "tw:text-4xl tw:font-bold tw:text-left tw:max-w-[350px] tw:md:max-w-[500px] tw:h-[200px] tw:md:h-[200px] tw:pl-[18px] tw:md:pl-[43px]", style: {
            color: theme.palette.text.primary,
        } },
        "Use Concierge to ",
        React__default.createElement(FlipWords, { words: words, duration: 4000 })));
}
const ConciergeWelcomeComponent = ({ trendingSearches, onSearch, brandId, isEmbedded = false, apiBaseUrl, }) => {
    const { data, isLoading: isLoadingSuggestedQueries } = useSuggestedQueries(brandId, apiBaseUrl);
    const theme = useTheme();
    // Memoize displayQueries to prevent recalculation on every render
    const displayQueries = React__default.useMemo(() => (data === null || data === void 0 ? void 0 : data.suggestedQuestions) || (trendingSearches === null || trendingSearches === void 0 ? void 0 : trendingSearches.map((search) => search.text)) || [], [data === null || data === void 0 ? void 0 : data.suggestedQuestions, trendingSearches]);
    // Get page context (always call hook, but only use when embedded)
    const pageContext = usePageContext();
    // Custom welcome screen for embedded mode
    if (isEmbedded) {
        return (React__default.createElement(ConciergeWelcomeEmbedded, { displayQueries: displayQueries, isLoadingSuggestedQueries: isLoadingSuggestedQueries, onSearch: onSearch, pageContext: pageContext }));
    }
    // Full welcome screen for non-embedded mode
    return (React__default.createElement("div", { style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '40px 20px',
            textAlign: 'center',
            width: '100%',
            height: '100%',
            boxSizing: 'border-box',
            overflow: 'auto',
        } },
        React__default.createElement(FlipWordsDemo, null),
        displayQueries.length > 0 && !isLoadingSuggestedQueries && (React__default.createElement("div", { style: { width: '100%', maxWidth: '1200px' } },
            React__default.createElement("div", { style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    marginBottom: '28px',
                } },
                React__default.createElement(Sparkles, { style: {
                        width: '18px',
                        height: '18px',
                        color: theme.palette.text.secondary,
                    } }),
                React__default.createElement("h3", { style: {
                        fontSize: '15px',
                        fontWeight: '600',
                        color: theme.palette.text.secondary,
                        margin: 0,
                        textTransform: 'uppercase',
                        letterSpacing: '0.05em',
                    } }, "For you")),
            React__default.createElement(AnimatedMasonryGrid, { items: displayQueries, onItemClick: onSearch })))));
};
// Memoize to prevent re-renders when parent re-renders due to input changes
const ConciergeWelcome = memo(ConciergeWelcomeComponent);

export { FlipWordsDemo, ConciergeWelcome as default };
//# sourceMappingURL=ConciergeWelcome.js.map
